export const APPEAL_DATA_API_URL='claims-overturn-reason-metrics';
export const APPEAL_DETAILS_DATA_API_URL='claims-appeals-summary';
export const APPEAL_DETAILS_DATA_BULK_API_URL= 'appeals-bulk-process-jobs/claims-appeals-summary';
export const APPEALS_MEASURE_DOR_HCO_REQUEST_TYPE="APPEALS_MEASURE_DOR_HCO";
export const APPEALS_MEASURE_DOR_TIN_REQUEST_TYPE="APPEALS_MEASURE_DOR_TIN";
export const APPEAL_TOP_OVERTURN_REASON_API_URL='appeal-overturn-reasons';
export const APPEALS_TOP_OVERTURN_REASON_DATA_BULK_API_URL='appeals-bulk-process-jobs/appeal-overturn-reasons';
export const APPEALS_TREND_DATA_API_URL='claims-appeals-trend';
export const APPEALS_TREND_DATA_BULK_API_URL='appeals-bulk-process-jobs/claims-appeals-trend';

export const getAppealsMeasureRequestType = (
	isContractIdFlow: boolean,
	isHcoFlow: boolean,
	isBulkFlow: boolean = false
): string => isBulkFlow
	? APPEALS_MEASURE_DOR_TIN_REQUEST_TYPE
	: isContractIdFlow
	? APPEALS_MEASURE_DOR_HCO_REQUEST_TYPE
	: isHcoFlow
		? APPEALS_MEASURE_DOR_HCO_REQUEST_TYPE
		: APPEALS_MEASURE_DOR_TIN_REQUEST_TYPE;
